import Page from '../page';

/**
 * Create the action
 */

const { thunk, request, success, error } = Page.index((fetch) => {
    return fetch.get('pages');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };